import { render, staticRenderFns } from "./ToggleDevolucao.vue?vue&type=template&id=38093d86"
import script from "./ToggleDevolucao.vue?vue&type=script&lang=js"
export * from "./ToggleDevolucao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports